import { usePrismicLabels } from "~/hooks/usePrismicLabel";

const SuccessIcon = () => (
  <svg
    className="campaign-success__icon"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="24" cy="24" r="22" fill="#22c55e" />
    <path
      d="M14 24 L21 31 L34 17"
      stroke="white"
      strokeWidth="3.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const LimitIcon = () => (
  <svg
    className="campaign-success__icon"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="24" cy="24" r="22" fill="#e5161c" />
    <path
      d="M16 16 L32 32 M32 16 L16 32"
      stroke="white"
      strokeWidth="3.5"
      strokeLinecap="round"
    />
  </svg>
);

interface CampaignTerminalStateProps {
  variant: "success" | "limit";
  message: string | null;
  homeHref: string;
}

const CampaignTerminalState = ({
  variant,
  message,
  homeHref,
}: CampaignTerminalStateProps) => {
  const { $pt } = usePrismicLabels();
  return (
    <div className="campaign-card__body campaign-success">
      {variant === "success" ? <SuccessIcon /> : <LimitIcon />}
      <p className="campaign-success__text">{message}</p>
      <a href={homeHref} className="link campaign-success__link">
        {$pt("campaign_back_to_home")}
      </a>
    </div>
  );
};

export default CampaignTerminalState;
